module.exports = {
  appId: 'd75e63e2-34b2-4987-8457-e18c013a819b',
  apiKey: '14b8a5e7-eef8-4830-bffe-d39b5f7a281e',
  siteName: 'Gatsby React Bricks starter',
  author: '@matfrana',
}
